// idk what the hell is going on with formatting in this file- prettier seems to have lost it's mind

import React from "react";

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
        expanded: false
    };
  }

  toggle() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const {q, a} = this.props
    return (
        
        <div className="question" key={q.slice(0, 25)}>
            <div className="row" onClick={this.toggle}>
              <h4>{q}</h4>
              <div className="toggle">
                { this.state.expanded && (
                  <i className='bx bx-chevron-up'></i>
                ) }
                { this.state.expanded == false && (
                  <i className='bx bx-chevron-down'></i>
                ) }
              </div>
            </div>
            { this.state.expanded && (
                <div className="answer">
                    <p>{a}</p>
                </div>
            ) }
        </div>


      )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/good_components/FAQ.jsx